import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

const Header = (props) => {
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    props.onMenuClick();
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div className="header">
      {/* Sidebar Toggle */}
      <Link
        to="#"
        className="flex items-center text-gray-500 inline-flex float-left text-3xl w-6 h-12 mx-0 my-0 mx-8 px-0 py-0"
        id="toggle_btn"
        onClick={handlesidebar}
      >
        <span className="relative block top-[-10px]">
          <span className="absolute bg-gray-500 rounded-full h-1 w-6 top-1" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-3 top-3" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-5 top-5" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-2 top-7" />
        </span>
      </Link>
      {/* /Sidebar Toggle */}
      {/* Mobile Menu Toggle */}
      <Link
        to="#"
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <span className="relative block top-[10px]">
          <span className="absolute bg-gray-500 rounded-full h-1 w-6 top-1" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-3 top-3" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-5 top-5" />
          <span className="absolute bg-gray-500 rounded-full h-1 w-2 top-7" />
        </span>
      </Link>
      {/* /Mobile Menu Toggle */}
      {/* Header Menu */}
      <ul className="float-right mr-0 z-99 flex border-0 h-16 items-center">
        <li className="my-0 mx-2">
          <Link
            to="#"
            className="toggle-switch moon-switch bg-gray-200 w-10 h-10 flex items-center justify-center rounded-full text-2xl"
          >
            {/* <i className="fe fe-moon" /> */}
            <FeatherIcon icon="moon" className="w-4 h-4" />
          </Link>
        </li>
        <li className="my-0 mx-2">
          <Link
            className="nav-link bell-icon bg-gray-200 w-10 h-10 flex items-center justify-center rounded-full text-2xl"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
          >
            {/* <i className="fe fe-bell" /> */}
            <FeatherIcon icon="bell" className="w-4 h-4" />
            <span className="badge rounded-pill" />
          </Link>
          <div className="border border-gray-200 rounded-lg transform-origin-top-left bg-white p-0 shadow-sm overflow-hidden hidden">
            <div className="border-b-[1px] border-gray-200 text-center text-sm h-8 leading-8 px-4">
              <span className="notification-title">Notifications</span>
              <Link to="#" className="clear-noti">
                Clear All
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                <li className="notification-message">
                  <Link to="/profile">
                    <div className="media d-flex">
                      <span className="avatar avatar-sm">
                        <img className="avatar-img rounded-circle" alt="" />
                      </span>
                      <div className="media-body">
                        <p className="noti-details">
                          <span className="noti-title">Brian Johnson</span> paid
                          the invoice
                          <span className="noti-title">#DF65485</span>
                        </p>
                        <p className="noti-time">
                          <span className="notification-time">4 mins ago</span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="notification-message">
                  <Link to="/profile">
                    <div className="media d-flex">
                      <span className="avatar avatar-sm">
                        <img className="avatar-img rounded-circle" alt="" />
                      </span>
                      <div className="media-body">
                        <p className="noti-details">
                          <span className="noti-title">Marie Canales</span> has
                          accepted your estimate
                          <span className="noti-title">#GTR458789</span>
                        </p>
                        <p className="noti-time">
                          <span className="notification-time">6 mins ago</span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="notification-message">
                  <Link to="/profile">
                    <div className="media d-flex">
                      <div className="avatar avatar-sm">
                        <span className="avatar-title rounded-circle bg-primary-light">
                          <i className="far fa-user" />
                        </span>
                      </div>
                      <div className="media-body">
                        <p className="noti-details">
                          <span className="noti-title">
                            New user registered
                          </span>
                        </p>
                        <p className="noti-time">
                          <span className="notification-time">8 mins ago</span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="notification-message">
                  <Link to="/profile">
                    <div className="media d-flex">
                      <span className="avatar avatar-sm">
                        <img className="avatar-img rounded-circle" alt="" />
                      </span>
                      <div className="media-body">
                        <p className="noti-details">
                          <span className="noti-title">Barbara Moore</span>
                          declined the invoice
                          <span className="noti-title">#RDW026896</span>
                        </p>
                        <p className="noti-time">
                          <span className="notification-time">12 mins ago</span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="notification-message">
                  <Link to="/profile">
                    <div className="media d-flex">
                      <div className="avatar avatar-sm">
                        <span className="avatar-title rounded-circle bg-info-light">
                          <i className="far fa-comment" />
                        </span>
                      </div>
                      <div className="media-body">
                        <p className="noti-details">
                          <span className="noti-title">
                            You have received a new message
                          </span>
                        </p>
                        <p className="noti-time">
                          <span className="notification-time">2 days ago</span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link to="/notifications">View all Notifications</Link>
            </div>
          </div>
        </li>
        <li className="my-0 mx-2">
          <Link
            to="#"
            className="win-maximize maximize-icon bg-gray-200 w-10 h-10 flex items-center justify-center rounded-full text-2xl"
          >
            <FeatherIcon icon="maximize" className="w-4 h-4" />
          </Link>
        </li>
        {/* User Menu */}
        <li className="my-0 mx-2">
          <Link
            to="#"
            className="text-gray-700 font-normal text-sm px-3 py-2 h-14 flex items-center"
            data-bs-toggle="dropdown"
          >
            <span className="mr-3 relative rounded-full flex items-center justify-center">
              <img alt="img" className="w-10 h-10 rounded-full" />
              <span className="animate-pulse absolute border-solid border-2 border-purple-800 rounded-full w-10 h-10" />
            </span>
            <span className="user-content">
              <span className="user-details">Admin</span>
              {/* <span className="user-name"> Akii</span> */}
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user hidden">
            <div className="profilemenu">
              <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to="#">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/settings">
                      Settings
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                    <Link className="dropdown-item" to="/login">
                      Log Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>
  );
};
export default Header;
